import { KYCAuthorizationOriginSourceEnum } from '.spec/self-care/tsTypes';
import { useQuery } from '@apollo/client';
import React from 'react';

import { MyProfileQueryData } from '@skippay/core/@types/myProfile';
import Loader from '@skippay/core/components/Loader';
import Redirect from '@skippay/core/components/Redirect';
import useLocation from '@skippay/core/hooks/useLocation';
import { useIntl } from '@skippay/core/i18n/intl';

import SEO from 'components/SEO';
import { OVERVIEW } from 'constants/routes';
import MinimalLayout from 'layout/MinimalLayout';
import MyProfileQuery from 'queries/MyProfileQuery.graphql';

import BnplLimitManagement from './BnplLimitManagement';

function BnplLimitManagementScreen(): JSX.Element {
	const intl = useIntl();
	const {
		location: { query: { source } = {} },
	} = useLocation();

	const profileQuery = useQuery<MyProfileQueryData>(MyProfileQuery, {
		fetchPolicy: 'cache-and-network',
	});

	if (profileQuery.loading && !profileQuery.data) {
		return <Loader fullSize />;
	}

	const canApplyForBnplLimits = Boolean(profileQuery.data?.myProfile.options.canApplyForBnplLimits);
	const isReturningFromKyc = source === KYCAuthorizationOriginSourceEnum.BNPL_LIMITS_APPLICATION;

	if (!canApplyForBnplLimits && !isReturningFromKyc) {
		return <Redirect to={OVERVIEW} />;
	}

	return (
		<>
			<SEO
				title={intl.formatMessage({
					id: 'BnplLimitManagement.seo.title',
					defaultMessage: 'Nastavení limitů',
				})}
			/>
			<MinimalLayout testId="BNPLLimitManagement" header={{ closeLink: OVERVIEW }}>
				<BnplLimitManagement phoneNumbers={profileQuery.data?.myProfile.phoneNumbers} />
			</MinimalLayout>
		</>
	);
}

export default BnplLimitManagementScreen;
